module.exports = __webpack_public_path__ + "r-v3/img/sticker_5.b303bf95.svg";